import { render, staticRenderFns } from "./video.vue?vue&type=template&id=732e543e&"
import script from "./video.vue?vue&type=script&lang=ts&"
export * from "./video.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports